<router-outlet></router-outlet>
<ngx-snackbar [position]="'bottom-left'"></ngx-snackbar>
